/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";

import { useContext } from "react";
import { AuthContext } from "../../context/authentication-context";

const AuthButton = () => {
  const { user, login, logout } = useContext(AuthContext);
  console.log("user", user, useContext(AuthContext));
  return (
    <div className="absolute top-5 right-5">
      <button onClick={!user ? login : logout} sx={{ color: "white" }}>
        {!user ? "Staff Login" : "Logout"}
      </button>
    </div>
  );
};
export default AuthButton;
